<template minapp="mpx" xlang="wxml">
  <!-- todo @jiangzhengjie 客服调用示例 -->
  <!-- <HelpDeskChat
    bizType="train"
    onlineSource="{{onlineSource}}"
    onlineOrderId="{{onlineOrderId}}"
    phone="{{actionTitle}}"
    email="qweqweqwe"
  /> -->
  <customer-service 
    content="{{content}}" 
    titleKey="{{question}}" 
    listKey="{{answers}}" 
    phone="{{actionTitle}}"
    globalPhone="{{globalPhone}}"
  />
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { getCustomerService } from '@/api/customer-service'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'
  import { query } from '@didi/spring-base'

  createPage({
    data: {
      content: [],
      submitTitle: '',
      actionTitle: '',
      question: 'question',
      answers: 'answers',
      globalPhone: '',
      onlineSource: query().source,
      onlineOrderId: query().orderId,
    },
    mounted() {
      getCustomerService()
        .then(({ data, success, message, code }) => {
          if (success) {
            if (code === '0') {
              const { list, submit_title, action_title, intl_mobile } = data
              this.content = list
              this.submitTitle = submit_title
              this.actionTitle = action_title
              // this.globalPhone = intl_mobile
            } else {
              mpx.showToast({
                title: message, //提示的内容,
                icon: 'error', //图标,
                duration: 2000, //延迟时间,
                content: ''
              })
            }
          } else {
            mpx.showToast({
              title: LOAD_FAIL_CONTENT, //提示的内容,
              icon: 'error', //图标,
              duration: 2000, //延迟时间,
              content: ''
            })
          }
        })
        .finally(() => {
          mpx.hideLoading()
        })
    }
  })
</script>
<style scoped lang="stylus"></style>

<script name="json">
  module.exports = {
    usingComponents: {
      'customer-service': '@/material/template/service/index',
      'HelpDeskChat': '@didi/spring-ui/help-desk-chat'
    }
  }
</script>